// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7819) return "static/chunks/7819.69ef3e75d0c6589b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1985":"8d1e967bc1682050","3800":"2324d5630371b2c6","4181":"980ae8b2d8e136a8","4414":"d12b30d071bc80c4","4534":"75568f593c990fd6","4550":"cdce6d99682a07ef","5179":"73d3793fbcad0dca","5298":"5e8234c399223d3c","5375":"9d36e36d99087a27","6350":"c5882a09898e4113","7689":"f7778fbe98f06ead","7761":"8a27216f2dd8a2a7"}[chunkId] + ".js";
};